import React, { useMemo } from "react";
import ServerDataGrid from "views/pages/manage/common/data-grid/ServerDataGrid";
import ReceiptStatusChip from "../../../cash-management/components/ReceiptStatusChip";
import { getFormattedAmount } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { getChequeExtensionHistory } from "modules/paymentManagement/cash-management/api";
const formatDate = (dateString, includeTime = false) => {
  if (!dateString) return "-";
  const options = { year: "numeric", month: "2-digit", day: "2-digit" };
  if (includeTime) {
    options.hour = "2-digit";
    options.minute = "2-digit";
    options.hour12 = true;
  }
  return new Date(dateString)
    .toLocaleDateString("en-GB", options)
    .replace(",", "");
};

const ReceiptsList = ({
  rows,
  loading,
  pagination,
  onPageChange,
  onPageSizeChange,
  selectedIds,
  onSelectionChange,
  onViewCheque ,
  fetchTrackerTimeline
}) => {
  const handleViewReceipt = (row) => {
    alert(`Viewing receipt for: ${row.student}`);
  };

  // Memoize columns to prevent unnecessary re-renders
  const columns = useMemo(
    () => [
      {
        key: "psid",
        label: "PSID",
        width: 120,
        render: (value) => (
          <span
            style={{
              color: "#00B0F5",
              cursor: "pointer",
              textDecoration: "none",
            }}
            onClick={() =>
              window.open(`/#/admin/edp/studentDetails/${value}`, "_blank")
            }
          >
            {value}
          </span>
        ),
      },
            { key: "applicationId", label: "Application ID", sortable: true, width: 100 },

      { key: "studentName", label: "Student Name", sortable: true, width: 140 },
      {
        key: "bankName",
        label: "Bank Name",
        width: 120,
      },
      {
        key: "referenceNumber",
        label: "Cheque Number",
        width: 120,
      },
      {
        key: "extendedDate",
        label: "Cheque Date",
        sortable: true,
        width: 120,
        render: (value,row) => formatDate(value , false),
      },
      {
        key: "attachmentS3Key", // Using this key for the 'View' button column as per old config
        label: "Attachment",
        width: 120,
        align: "center",
        render: (_, row) => (
          <button
            className="btn btn-primary btn-sm"
            style={{ fontSize: "12px", padding: "4px 12px" }}
            onClick={() => onViewCheque(row)}
          >
            View
          </button>
        ),
      },
      { key: "term", label: "Term", width: 80 },
      { key: "receiptNo", label: "Receipt No.", width: 200 },
      {
        key: "receiptDate",
        label: "Receipt Date",
        sortable: true,
        width: 170,
        render: (value) => formatDate(value, true),
      },
      { key: "createdBy", label: "Cashier ID", width: 130 },
      {
        key: "lastUpdatedOn",
        label: "Last Updated On",
        width: 180,
        render: (value) => formatDate(value, true),
      },
      {
        key: "approvedOn",
        label: "Approved On",
        width: 160,
        render: (value) => formatDate(value, true),
      },
      {
        key: "status",
        label: "Status",
        width: 140,
        pinned: true,
        render: (value,row) => <ReceiptStatusChip status={value} row={row} fetchTrackerTimeLine={getChequeExtensionHistory}/>,
      },
      {
        key: "amountCollected",
        label: "Amt Collected",
        sortable: true,
        pinned: true,
        width: 150,
        align: "right",
        render: (value) => (
          <b style={{ color: "#0A942B" }}>
            {getFormattedAmount(value)}
          </b>
        ),
      },
    ],
    []
  );

  return (
    <ServerDataGrid
      rows={rows}
      loading={loading}
      columns={columns}
      rowKey="id"
      pagination={pagination}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      selectable={true}
      selectedIds={selectedIds}
      isSingleSelect = {false}
      onSelectionChange={onSelectionChange}
    />
  );
};

export default ReceiptsList;
